// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-G":"G_AU_outdoor-recreation-G__R2e1A"};